import type { VoidFunctionComponent } from 'react';

import useUpdateUserTeamRoles from '../../../../../hooks/api/users/useUpdateUserTeamRoles';
import TeamRoleSelector from '../TeamRoleSelector';

type Props = {
  userId: number;
  teamId: number;
  roleId?: number;
  isDisabled?: boolean;
};

/**
 * On each row of the TeamGroupMembersTable, this dropdown allows the current user
 * to change the role of the member quickly.
 *
 * @param {Props} props - The component props.
 * @param {number} props.userId - The ID of the user to change the role for.
 * @param {number} props.teamId - The ID of the team group to change the role for.
 * @param {number} props.roleId - The ID of the role to select.
 */
const TeamMembersTableRoleDropdown: VoidFunctionComponent<Props> = ({ userId, teamId, roleId, isDisabled }) => {
  const { mutate: updateUserTeamRoles } = useUpdateUserTeamRoles(teamId);

  return (
    <TeamRoleSelector
      userId={userId}
      roleId={roleId}
      teamId={teamId}
      isDisabled={isDisabled}
      handleChangeRole={(_userId, updatedRoleId: number) => {
        //  If the role ID is the same as the current role ID, do nothing.
        if (roleId === updatedRoleId) {
          return;
        }
        //  Otherwise, update the role. No need to await this.
        updateUserTeamRoles({
          userId,
          newRoles: [{
            teamId,
            roleId: updatedRoleId,
          }],
        });
      }}
    />
  );
};

export default TeamMembersTableRoleDropdown;
